module.exports = __webpack_public_path__ + "img/tokiomarine.317f0e50.png";